import { PublicationStatusSchema } from "../solo-cms/publication-status";
import { z } from "zod";

// ====== Response DTO (read) ======

export const SpinningWheelConfigSlotDtoSchema = z.object({
  amount: z.number(),
  tokenSymbol: z.string(),
  probability: z.string(),
});
export type SpinningWheelConfigSlotDto = z.infer<typeof SpinningWheelConfigSlotDtoSchema>;

export const SpinningWheelConfigDtoSchema = z.object({
  id: z.uuid(),
  name: z.string().min(1),
  description: z.string().nullable().optional(),
  startDate: z.coerce.date(),
  endDate: z.coerce.date().nullable().optional(),
  isActive: z.boolean(),
  minimumClaimThresholdUsd: z.number(),
  slots: z.array(SpinningWheelConfigSlotDtoSchema),
  locale: z.string().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type SpinningWheelConfigDto = z.infer<typeof SpinningWheelConfigDtoSchema>;

// ====== Save DTOs (write) ======

const BaseSpinningWheelConfigDtoSchema = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
  startDate: z.coerce.date(),
  endDate: z.coerce.date().nullable().optional(),
  isActive: z.boolean(),
  minimumClaimThresholdUsd: z.number(),
  slots: z.array(SpinningWheelConfigSlotDtoSchema).min(2).max(12),
  locale: z.string().nullable().optional(),
  publicationStatus: PublicationStatusSchema,
});

export const CreateSpinningWheelConfigDtoSchema = BaseSpinningWheelConfigDtoSchema;
export type CreateSpinningWheelConfigDto = z.infer<typeof CreateSpinningWheelConfigDtoSchema>;

export const UpdateSpinningWheelConfigDtoSchema = BaseSpinningWheelConfigDtoSchema.extend({
  id: z.uuid(),
});
export type UpdateSpinningWheelConfigDto = z.infer<typeof UpdateSpinningWheelConfigDtoSchema>;

export const SaveSpinningWheelConfigDtoSchema = z.union([
  UpdateSpinningWheelConfigDtoSchema,
  CreateSpinningWheelConfigDtoSchema,
]);
export type SaveSpinningWheelConfigDto = z.infer<typeof SaveSpinningWheelConfigDtoSchema>;

// ====== Query params ======

export const GetSpinningWheelConfigByIdQueryParamsSchema = z.object({
  spinningWheelConfigId: z.uuid(),
});
export type GetSpinningWheelConfigByIdQueryParamsDto = z.infer<typeof GetSpinningWheelConfigByIdQueryParamsSchema>;

export const GetSpinningWheelConfigsByPageQueryParamsSchema = z.object({
  page: z.coerce.number().optional(),
  size: z.coerce.number().optional(),
  search: z.string().optional(),
});
export type GetSpinningWheelConfigsByPageQueryParamsDto = z.infer<
  typeof GetSpinningWheelConfigsByPageQueryParamsSchema
>;

export const DeleteSpinningWheelConfigQueryParamsSchema = z.object({
  spinningWheelConfigId: z.uuid(),
});
export type DeleteSpinningWheelConfigQueryParamsDto = z.infer<typeof DeleteSpinningWheelConfigQueryParamsSchema>;

// ====== Result schemas ======

export const GetSpinningWheelConfigsByPageResultSchema = z.object({
  data: z.array(SpinningWheelConfigDtoSchema),
  total: z.number(),
  page: z.number(),
  size: z.number(),
});
export type GetSpinningWheelConfigsByPageResultDto = z.infer<typeof GetSpinningWheelConfigsByPageResultSchema>;
